import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';

/**
 * "Security check" row: shows the arithmetic question next to an answer input.
 * Must be placed inside an element carrying a [formGroup] directive; it binds
 * to the control named by `controlName` on that group.
 */
@Component({
  selector: 'app-captcha-field',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  template: `
    <div class="field">
      <label [attr.for]="inputId">Security check</label>
      <div class="captcha-row">
        <span class="captcha-q" aria-live="polite">{{ question }}</span>
        <input
          [id]="inputId"
          type="text"
          inputmode="numeric"
          autocomplete="off"
          class="form-control captcha-a"
          placeholder="Answer"
          [formControlName]="controlName"
          [class.is-invalid]="invalid"
        />
      </div>
      <p class="field-error" *ngIf="invalid">Please answer the security question.</p>
    </div>
  `
})
export class CaptchaFieldComponent {
  @Input({ required: true }) question = '';
  @Input() controlName = 'captchaInput';
  @Input() inputId = 'captchaInput';
  @Input() invalid = false;
}
